var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLeave = function SvgLeave(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3307 3.33301V12.6663C13.3307 13.771 12.4354 14.6663 11.3307 14.6663H4.66406C3.5594 14.6663 2.66406 13.771 2.66406 12.6663V3.33301C2.66406 2.22834 3.5594 1.33301 4.66406 1.33301H11.3307C12.4354 1.33301 13.3307 2.22834 13.3307 3.33301Z",
    fill: "#F3CED2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.66699H7.33333C6.59667 6.66699 6 7.26366 6 8.00033C6 8.73699 6.59667 9.33366 7.33333 9.33366H12V6.66699Z",
    fill: "#EA5353"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0547 10.7541C11.0547 11.2681 11.6747 11.5267 12.04 11.1647L14.6354 8.59405C14.9654 8.26672 14.9654 7.73339 14.6354 7.40605L12.04 4.83539C11.6747 4.47405 11.0547 4.73272 11.0547 5.24605V10.7541Z",
    fill: "#EA5353"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLeave);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "leave.3d976dfc4e15ecec98e748ed302aee53.svg";